import { useState } from "react";
import { categories, latestFeed } from "@/mocks/chigua";
import SectionHeading from "./SectionHeading";

const filters = ["全部", ...categories.map((c) => c.name)];

export default function Feed() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? latestFeed : latestFeed.filter((f) => f.cat === active);

  return (
    <section id="latest" className="scroll-mt-16 bg-background-100/60 py-16 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            eyebrow="最新收录"
            title="爆料截图，持续归档中"
            desc="按事件归类、按时间排序。切到某个分类，只看你最关心的那类瓜。"
          />
          <p className="mb-8 hidden whitespace-nowrap text-sm text-foreground-400 lg:mb-10 lg:block">
            共收录 <span className="font-semibold text-foreground-800">{latestFeed.length + 87000}</span> 套事件图集
          </p>
        </div>

        <div
          className="mb-8 flex flex-wrap items-center gap-2"
          role="group"
          aria-label="按分类筛选最新收录"
        >
          {filters.map((f) => (
            <button
              key={f}
              onClick={() => setActive(f)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition ${
                active === f
                  ? "bg-foreground-950 font-medium text-background-50"
                  : "border border-background-300/70 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {list.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition hover:-translate-y-1 hover:border-primary-200"
            >
              <a href="#timeline" className="relative block overflow-hidden" aria-label={`${item.title} 的整理时间线`}>
                <img
                  src={item.imgs[0]}
                  alt={`${item.title} 图集封面`}
                  className="aspect-[16/10] w-full object-cover transition duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 flex items-center gap-1 whitespace-nowrap rounded-full bg-foreground-950/80 px-2.5 py-1 text-[11px] font-medium text-background-50 backdrop-blur">
                  <i className="ri-price-tag-3-line" />
                  {item.tag}
                </span>
              </a>
              <div className="flex flex-1 flex-col p-4">
                <p className="mb-1 flex items-center gap-2 text-[11px] text-foreground-400">
                  <span className="rounded bg-secondary-100 px-1.5 py-0.5 font-medium text-secondary-800">{item.cat}</span>
                  <span>{item.date}</span>
                  <span className="flex items-center gap-0.5">
                    <i className="ri-eye-line" />
                    {item.reads}
                  </span>
                </p>
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950">
                  <a href="#timeline" className="transition hover:text-primary-600">
                    {item.title}
                  </a>
                </h3>
                <p className="mt-2 line-clamp-2 flex-1 text-xs leading-relaxed text-foreground-500">{item.excerpt}</p>
                <a
                  href="#timeline"
                  className="mt-4 inline-flex items-center gap-1 self-start whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900 transition group-hover:bg-primary-500 group-hover:text-background-50"
                >
                  查看时间线
                  <i className="ri-arrow-right-line" />
                </a>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-10 text-center text-sm text-foreground-400">今日图集已同步，返回顶部可切换更多分类 ↓</p>
      </div>
    </section>
  );
}